import { tokens } from '@fluentui/react-components';
import { STATUS_BLUE } from '@shared/constants/colors.constants';
import { ESubmissionItemStatus } from '../../types/submissions.types';

export const SUBMISSION_ITEMS_TAB_VALUE_ALL = 'ALL';

export const SUBMISSION_ITEMS_TABLE_COLUMN_IDS = [
  'name',
  'status',
  'assignee',
  'dueDate',
  'submittedVersion',
  'latestVersion',
  'approvedVersion',
];

export const SUBMISSION_ITEM_STATUS_COLORS: Record<ESubmissionItemStatus, string | undefined> = {
  [ESubmissionItemStatus.BACKLOG]: undefined, // default
  [ESubmissionItemStatus.IN_PROGRESS]: STATUS_BLUE,
  [ESubmissionItemStatus.IN_REVIEW]: STATUS_BLUE,
  [ESubmissionItemStatus.ACCEPTED]: tokens.colorBrandBackground,
};
